import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, MenuItem, TextField, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { ArrowBack, Assignment, Edit, PlaylistAdd, Save, Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CurrencyInput } from '../../components/CurrencyInput';
import ResumoDrawer from '../../components/ResumoDrawer';
import Page from '../../containers/Page/Page';
import { useAuth } from '../../hooks/auth';
import { useLoading } from '../../hooks/loading';
import { api } from '../../services/api';
import { IResumo } from '../../types/Resumo';
import { Helpers } from '../../utils/Helpers';

interface ICaracteristica {
    id: string;
    label: string;
    valor: string;
}

interface IBomba {
    id: string;
    codigo_sap: string;
    lin_sap: string;
    tamanho: string;
    modelo: string;
    cpp: boolean;
    caracteristicas: ICaracteristica[];
    permite_alterar: boolean;
}

interface IProposta {
    finalidade: string;
    uf_destino: string;
    nao_contribuinte: boolean;
}


interface ITabela {
    moeda: string;
    cpp_valor: string;
    cpp_valor_original: string;
    cpp_descadc: string;
    cpp_taxa_reais: string;
    cpp_porcentagem: string;
    terceiros_referencia: string;
    terceiros_bruto: string;
    terceiros_taxa_reais: string;
    terceiros_precoun: string;
    terceiros_descforn: string;
    terceiros_desc_adicional: string;
    terceiros_fatdesc: string;
    terceiros_icmsret: string;
    terceiros_piscofinsret: string;
    terceiros_margem_revenda: string;
    terceiros_fatimp: string;
    terceiros_liquido: string;
}

interface IImpostos {
    lin_sap: string;
    qtd: string;
    fat_enc: string;
    pis_cofins: string;
    icms: string;
    ipi: string;
    preco_unitario_liquido: string;
    preco_unitario_liquido_com_imposto: string;
    preco_total_liquido: string;
    preco_total_liquido_com_imposto: string;
    margem: string;
    total_liquido_fate: string;
    custo: string;
    fator_vendas: string;
    fator_custo: string;
    tipo_preco: string;
    cpp: string;
}

interface IEncargo {
    encargo: string;
    embalagem: string;
    frete: string;
    comissao: string;
    negociacao: string;
    custo_exportacao: string;
}

interface ITributo {
    campo: string;
    preenchido: boolean;
    disabled: boolean;
    changed: boolean;
    proximo: boolean;
    valor: string;
    valores: {
        cod: string;
        desc: string;
    }[];
}

interface IDescontos {
    lista_desc_inf_comercial: string;
    lista_desc_cliente: string;
    cpp_desc_inf_comercial: string;
    cpp_desc_cliente: string;
    terceiros_desc_inf_comercial: string;
    terceiros_desc_cliente: string;
}

interface IPrazo {
    prazo: string;
}

interface IConversao {
    brl: string;
    eur: string;
    upk: string;
    usd: string;
}

interface ICabecalho {
    tag: string;
    servico: string;
    prazo_entrega: string;
}

interface IParams {
    id: string;
    modelo: string;
}

function PropostasDummy() {

    const history = useHistory();
    const classes = useStyles();
    const params = useParams<IParams>();
    const { data } = useAuth();

    const { startLoading, stopLoading, isLoading } = useLoading();

    const { enqueueSnackbar: alert } = useSnackbar();

    const [error, setError] = React.useState<string>('');
    const [loadingCount, setLoadingCount] = React.useState<number>(0);
    const [bomba, setBomba] = React.useState<IBomba>({} as IBomba);
    const [proposta, setProposta] = React.useState<IProposta>({} as IProposta);
    const [tabela, setTabela] = React.useState<ITabela>({} as ITabela);
    const [tributos, setTributos] = React.useState<ITributo[]>([]);
    const [impostos, setImpostos] = React.useState<IImpostos>({} as IImpostos);
    const [impostosEdit, setImpostosEdit] = React.useState<boolean>(false);
    const [encargos, setEncargos] = React.useState<IEncargo>({} as IEncargo);
    const [updateImpostos, setUpdateImpostos] = React.useState<string>('');
    const [descontos, setDescontos] = React.useState<IDescontos>({} as IDescontos);
    const [resumo, setResumo] = React.useState<IResumo>({} as IResumo);
    const [resumoError, setResumoError] = React.useState<string>('');
    const [resumoDrawer, setResumoDrawer] = React.useState<boolean>(false);
    const [conversao, setConversao] = React.useState<IConversao>({} as IConversao);
    const [cabecalho, setCabecalho] = React.useState<ICabecalho>({} as ICabecalho);
    const [prazos, setPrazos] = React.useState<IPrazo[]>([]);
    const [prazosInput, setPrazosInput] = React.useState<string>('');
    const [buscarDialog, setBuscarDialog] = React.useState<boolean>(false);
    const [precoResponse, setPrecoResponse] = React.useState<boolean>(false);
    const [descricaoCPP, setDescricaoCPP] = React.useState<string>('');

    const loading = loadingCount > 0;

    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchResumo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchPrazos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        recalculateImpostos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabela, updateImpostos]);

    React.useEffect(() => {
        setTabela({
            ...tabela,
            moeda: 'R$',
            terceiros_icmsret: '0',
            terceiros_piscofinsret: '0',
            terceiros_margem_revenda: '65',
            terceiros_fatimp: '1'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handleFetch() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post(`propostas/dummy/${params.modelo}/bomba`, {});
            const { object } = response.data;
            const parsed = object.impostos.tributos_json ? JSON.parse(object.impostos.tributos_json) : {};
            setBomba(object);
            if (object.proposta) setProposta(object.proposta);
            if (object.preco) setTabela(object.preco);
            if (object.preco) setPrecoResponse(true);
            if (parsed.tributos) setTributos(parsed.tributos);
            if (object.impostos) setImpostos(object.impostos);
            if (object.encargos) setEncargos(object.encargos);
            if (object.descontos) setDescontos(object.descontos);
            if (object.conversao) setConversao(object.conversao);
            if (object.cabecalho) setCabecalho(object.cabecalho);
            if (object.cabecalho) setPrazosInput(object.cabecalho.prazo_entrega);
            await handleFetchDescricaoCPP(object.impostos, object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleChangeTributos(index: number, value: string) {
        let newTributos = [...tributos.map(t => { return { ...t, changed: false } })];
        newTributos[index] = { ...newTributos[index], preenchido: true, changed: true, valor: value };
        setTributos(newTributos);
        startLoading('tributos');
        try {
            //Alterar opção de tributos e trazer os valores de impostos
            const response = await api.post('propostas/impostos', {
                tributos: newTributos,
                impostos: impostos,
                proposta: proposta,
            });
            const { object } = response.data;
            setTributos(object.tributos);
            setImpostos({
                ...impostos,
                icms: object.impostos.aliq_icm,
                pis_cofins: object.impostos.aliq_pis,
                ipi: object.impostos.aliq_ipi
            });
            setUpdateImpostos(Date.now().toString());
            //Disparar o auto-save para salvar novos valores de impostos
            await api.post(`precos/${params.modelo}`, {
                ...tabela,
                ...impostos,
                ...encargos,
                ...descontos,
                ...cabecalho,
                icms: object.impostos.aliq_icm,
                pis_cofins: object.impostos.aliq_pis,
                ipi: object.impostos.aliq_ipi,
                lin_sap: bomba.lin_sap,
                tipo_preco: impostos.tipo_preco,
                fat_enc: getFatEncargos(),
                lista_taxa_reais: getTaxaMoeda(),
                cpp_total_original: getPrecoLiqCPP(),
                cpp_valor: getConvertido(tabela.cpp_valor_original),
                cpp_fatdesc: getFatDescCPP(),
                cpp_taxa_reais: getTaxaMoeda(),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(),
                tributos_json: JSON.stringify({
                    tributos: object.tributos,
                    impostos: {
                        aliq_icm: object.impostos.aliq_icm,
                        aliq_pis: object.impostos.aliq_pis,
                        aliq_ipi: object.impostos.aliq_ipi,
                    }
                })
            });
        } catch (error: any) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('tributos');
        }
    }

    async function handleAutoSave() {
        try {
            await api.post(`propostas/dummy/${params.modelo}/bomba`, {
                ...bomba,
                ...impostos,
                ...encargos,
                ...cabecalho,
                fat_enc: getFatEncargos(),
            });
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    async function handleFetchPrazos() {
        try {
            const response = await api.get('prazos');
            setPrazos(response.data.object);
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    async function handleFetchDescricaoCPP(imp: IImpostos = impostos, bmb: IBomba = bomba) {
        try {
            const response = await api.post('/precos', {
                tipo: imp.tipo_preco,
                tipo_consulta: 'bomba',
                tipo_variante: 'MEGACPK',
                codigo_sap: bmb.codigo_sap,
                cpp: imp.cpp,
                proposta_id: params.id,
                modelo_proposta_id: params.modelo,
                mercado: data.user.mercado,
                apenas_consulta: true
            });
            setDescricaoCPP(response.data.preco.desc_cpp);
        } catch (error) {
            setDescricaoCPP('');
        }
    }

    async function handleCheckPreco() {
        if (impostos.tipo_preco === 'CPP' && !impostos.cpp) {
            alert('É necessário informar o código CPP para esse tipo de preço', { variant: 'warning' });
        } else {
            if (tabela.cpp_valor_original) {
                setBuscarDialog(true);
            } else {
                await handleFetchPreco();
            }
        }
    }

    async function handleFetchPreco() {
        setBuscarDialog(false);
        setLoadingCount(c => c + 1);
        try {
            //Buscar Preço
            const response = await api.post('/precos', {
                tipo: impostos.tipo_preco,
                tipo_consulta: 'bomba',
                tipo_variante: 'MEGACPK',
                codigo_sap: bomba.codigo_sap,
                cpp: impostos.cpp,
                proposta_id: params.id,
                modelo_proposta_id: params.modelo,
                mercado: data.user.mercado
            });
            setTabela(response.data.preco);
            setImpostos({
                ...impostos,
                fator_custo: response.data.preco.fator_custo,
                fator_vendas: response.data.preco.fator_vendas
            });

            //Cálculos
            let preco_unitario_liquido = getPrecoUnLiq(response.data.preco);
            let preco_unitario_liquido_com_imposto = getPrecoUnLiqImp(preco_unitario_liquido);
            let preco_total_liquido = (getValue(preco_unitario_liquido) * getValue(impostos.qtd)).toFixed(2);
            let preco_total_liquido_com_imposto = (getValue(preco_unitario_liquido_com_imposto) * getValue(impostos.qtd)).toFixed(2);
            let total_liquido_fate = (getValue(preco_unitario_liquido) * getValue(getFatEncargos())).toFixed(2);
            let margem = (100 - (getValue(impostos.custo) * 100) / getValue(total_liquido_fate)).toFixed(2);
            if (!isFinite(parseFloat(margem))) margem = "0.00";

            //Auto-Save
            await api.post(`precos/${params.modelo}`, {
                ...response.data.preco,
                ...impostos,
                ...encargos,
                ...descontos,
                ...cabecalho,
                fator_custo: response.data.preco.fator_custo,
                fator_vendas: response.data.preco.fator_vendas,
                preco_unitario_liquido: preco_unitario_liquido,
                preco_unitario_liquido_com_imposto: preco_unitario_liquido_com_imposto,
                preco_total_liquido: preco_total_liquido,
                preco_total_liquido_com_imposto: preco_total_liquido_com_imposto,
                total_liquido_fate: total_liquido_fate,
                margem: margem,
                lin_sap: bomba.lin_sap,
                tipo_preco: impostos.tipo_preco,
                fat_enc: getFatEncargos(),
                cpp_total_original: getPrecoLiqCPP(response.data.preco),
                cpp_valor: getConvertido(response.data.preco.cpp_valor_original, response.data.preco.moeda),
                cpp_fatdesc: getFatDescCPP(),
                cpp_taxa_reais: getTaxaMoeda(response.data.preco.moeda),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(response.data.preco.moeda),
                tributos_json: JSON.stringify({
                    tributos: tributos,
                    impostos: {
                        aliq_icm: impostos.icms,
                        aliq_pis: impostos.pis_cofins,
                        aliq_ipi: impostos.ipi
                    }
                })
            });
            setPrecoResponse(true);
        } catch (error) {
            Helpers.error(error, alert);
            setPrecoResponse(false);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleFetchResumo() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.get(`resumo/${params.modelo}`);
            setResumo(response.data.object);
            setResumoError('');
        } catch (error: any) {
            setResumoError(Helpers.errorFormat(error));
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleSave() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post(`precos/${params.modelo}`, {
                ...tabela,
                ...impostos,
                ...encargos,
                ...descontos,
                ...cabecalho,
                lin_sap: bomba.lin_sap,
                fat_enc: getFatEncargos(),
                cpp_total_original: getPrecoLiqCPP(),
                cpp_valor: getConvertido(tabela.cpp_valor_original),
                cpp_fatdesc: getFatDescCPP(),
                cpp_taxa_reais: getTaxaMoeda(),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(),
                tributos_json: JSON.stringify({
                    tributos: tributos,
                    impostos: {
                        aliq_icm: impostos.icms,
                        aliq_pis: impostos.pis_cofins,
                        aliq_ipi: impostos.ipi
                    }
                })
            });
            alert(response.data.message, { variant: 'success' });
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleAutoSavePreco() {
        try {
            await api.post(`precos/${params.modelo}`, {
                ...tabela,
                ...impostos,
                ...encargos,
                ...descontos,
                ...cabecalho,
                lin_sap: bomba.lin_sap,
                fat_enc: getFatEncargos(),
                cpp_total_original: getPrecoLiqCPP(),
                cpp_valor: getConvertido(tabela.cpp_valor_original),
                cpp_fatdesc: getFatDescCPP(),
                cpp_taxa_reais: getTaxaMoeda(),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(),
                tributos_json: JSON.stringify({
                    tributos: tributos,
                    impostos: {
                        aliq_icm: impostos.icms,
                        aliq_pis: impostos.pis_cofins,
                        aliq_ipi: impostos.ipi
                    }
                })
            });
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    function handleChange(caracteristica: ICaracteristica, value: string) {
        let index = bomba.caracteristicas.indexOf(caracteristica);
        let newCaracteristicas = bomba.caracteristicas;
        newCaracteristicas[index] = { ...caracteristica, valor: value };
        setBomba({ ...bomba, caracteristicas: newCaracteristicas });
    }

    async function handleChangeReferencia(value: string) {
        setLoadingCount(c => c + 1);
        try {
            await api.post(`propostas/dummy/${params.modelo}/bomba`, {
                ...bomba,
                ...impostos,
                ...cabecalho,
                tipo_preco: value
            });
            setImpostos({
                ...impostos,
                tipo_preco: value,
                fator_custo: '1',
                fator_vendas: '1'
            });
            setPrecoResponse(false);
            resetPreco();
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    function handleChangeImpostos(target: keyof IImpostos, value: string) {
        let newValues = impostos;
        newValues[target] = value;
        setImpostos(newValues);
        recalculateImpostos();
    }

    function handleChangePrazo(value: string) {
        setPrazosInput(value);
        setCabecalho({ ...cabecalho, prazo_entrega: value });
    }

    function resetPreco() {
        setTabela({
            ...{} as ITabela,
            moeda: "R$",
            terceiros_icmsret: '0',
            terceiros_piscofinsret: '0',
            terceiros_margem_revenda: '65',
            terceiros_fatimp: '1'
        });
    }

    function recalculateImpostos() {
        let preco_unitario_liquido = getPrecoUnLiq();
        let preco_unitario_liquido_com_imposto = getPrecoUnLiqImp(preco_unitario_liquido);
        let preco_total_liquido = (getValue(preco_unitario_liquido) * getValue(impostos.qtd)).toFixed(2);
        let preco_total_liquido_com_imposto = (getValue(preco_unitario_liquido_com_imposto) * getValue(impostos.qtd)).toFixed(2);
        let total_liquido_fate = (getValue(preco_unitario_liquido) * getValue(getFatEncargos())).toFixed(2);
        let margem = (100 - (getValue(impostos.custo) * 100) / getValue(total_liquido_fate)).toFixed(2);
        if (!isFinite(parseFloat(margem))) margem = "0.00";
        setImpostos({
            ...impostos,
            preco_unitario_liquido: preco_unitario_liquido,
            preco_unitario_liquido_com_imposto: preco_unitario_liquido_com_imposto,
            preco_total_liquido: preco_total_liquido,
            preco_total_liquido_com_imposto: preco_total_liquido_com_imposto,
            total_liquido_fate: total_liquido_fate,
            margem: margem
        });
    }

    function getPrecoUnLiq(table: ITabela = tabela) {
        if (impostos.tipo_preco === "CPP") {
            return getPrecoLiqCPP(table);
        } else {
            return getPrecoLiqTer();
        }
    }

    function getPrecoUnLiqImp(price: string) {
        let imps = (getValue(price) * ((getValue(impostos.icms) + getValue(impostos.ipi)) / 100));
        return (getValue(price) + imps).toFixed(2);
    }

    function getPrecoLiqCPP(table: ITabela = tabela) {
        let valor_convertido = getConvertido(table.cpp_valor_original, table.moeda);
        let valor_total = (getValue(valor_convertido) * getValue(getFatDescCPP()) * getValue(getFatDescAdcCPP()) / getValue(getFatEncargos())).toFixed(2);
        return isNaNOrUndefined(valor_total) ? "0" : valor_total;
    }

    function getPrecoLiqTer() {
        let fator_revenda = (1 / (1 - (getValue(tabela.terceiros_margem_revenda) / 100)));
        let valor_total = (getValue(getPrecoCompraTer()) * getValue(getFatDescTer()) * getValue(getFatDescAdcTer()) * fator_revenda / getValue(impostos.fat_enc)).toFixed(2);
        return isNaNOrUndefined(valor_total) ? "0" : valor_total;
    }

    function getFatDescCPP() {
        return (getValue(descontos.cpp_desc_inf_comercial) * getValue(descontos.cpp_desc_cliente)).toString();
    }

    function getFatDescTer() {
        return (getValue(descontos.terceiros_desc_inf_comercial) * getValue(descontos.terceiros_desc_cliente)).toString();
    }

    function getFatDescAdcCPP() {
        return (1 - (getValue(tabela.cpp_descadc) / 100)).toString();
    }

    function getFatDescAdcTer() {
        return (1 - (getValue(tabela.terceiros_desc_adicional) / 100)).toString();
    }

    function getFatRevTer() {
        return (1 / (1 - (getValue(tabela.terceiros_margem_revenda) / 100))).toFixed(2);
    }

    function getPrecoBrutoSemImpostosTer() {
        let impostos = (1 - (getValue(tabela.terceiros_icmsret) / 100)) * (1 - (getValue(tabela.terceiros_piscofinsret) / 100));
        return ((getValue(tabela.terceiros_bruto) * impostos)).toString();
    }

    function getPrecoCompraTer() {
        let descforn = (1 - (getValue(tabela.terceiros_descforn) / 100));
        return (getValue(getConvertido(getPrecoBrutoSemImpostosTer())) * getValue(tabela.terceiros_fatimp) * descforn).toString();
    }

    function getConvertido(value: string, currency: string = tabela.moeda) {
        return (getValue(value) * getValue(getTaxaMoeda(currency))).toString();
    }

    function getTaxaMoeda(currency: string = tabela.moeda) {
        let moeda;
        if (currency) {
            if (currency === "R$" && impostos.tipo_preco !== "CPP") moeda = "brl";
            else if (currency === "USD" && impostos.tipo_preco === "CPP") moeda = "usd_cpp";
            else if (currency === "R$" && impostos.tipo_preco === "CPP") moeda = "brl_cpp";
            else moeda = currency.toLowerCase();
        }
        return conversao[moeda as keyof typeof conversao];
    }

    function getLimit(value: string, min: number, max: number) {
        let num = Number.parseFloat(value);
        if (num > max) num = max;
        if (num < min) num = min;
        return !Number.isNaN(num) ? num.toString() : '';
    }

    function getValue(value: string) {
        let newValue = +value || 0;
        return newValue;
    }

    function getFatEncargos() {
        const fatores = getValue(encargos.encargo)
            + getValue(encargos.embalagem)
            + getValue(encargos.frete)
            + getValue(encargos.comissao)
            + getValue(encargos.negociacao)
            + getValue(encargos.custo_exportacao);
        return (1 - (fatores / 100)).toFixed(4);
    }

    function getTotalEncargos() {
        return (getValueEncargos(encargos.encargo)
            + getValueEncargos(encargos.embalagem)
            + getValueEncargos(encargos.frete)
            + getValueEncargos(encargos.comissao)
            + getValueEncargos(encargos.negociacao)
            + getValueEncargos(encargos.custo_exportacao)).toFixed(2);
    }

    function getValueEncargos(value: string) {
        let newValue = value ? Number.parseFloat(value.toString().replace(/,/g, '.')) || 0 : 0;
        return newValue;
    }

    function getTributosHighlight(tributo: ITributo) {
        if (tributo && tributo.proximo) return { notchedOutline: classes.highlight };
        else return {};
    }

    function isNaNOrUndefined(value: string) {
        return Number.isNaN(getValue(value)) || getValue(value) === undefined;
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <IconButton size="small" color="primary" className={classes.backButton} onClick={() => history.push(`/propostas/${params.id}`)}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        {bomba.permite_alterar ? 'Especificar Bomba' : 'Visualizar Bomba'}
                    </Typography>
                </Box>
                <Box display="flex">
                    <Box>
                        <Button
                            color="default"
                            variant="contained"
                            startIcon={<Assignment />}
                            onClick={() => setResumoDrawer(true)}>
                            Resumo
                        </Button>
                        <ResumoDrawer
                            data={resumo}
                            open={resumoDrawer}
                            error={resumoError}
                            onClose={() => setResumoDrawer(false)}
                        />
                    </Box>
                    <Box ml={2}>
                        <Button
                            color="secondary"
                            variant="contained"
                            startIcon={<PlaylistAdd />}
                            onClick={() => history.push(`/propostas/${params.id}/modelo/${params.modelo}/acessorios`)}>
                            {bomba.permite_alterar ? 'Especificar Acessórios' : 'Visualizar Acessórios'}
                        </Button>
                    </Box>
                    {bomba.permite_alterar &&
                        <Box ml={2}>
                            <Button
                                color="primary"
                                variant="contained"
                                startIcon={<Save />}
                                onClick={() => handleSave()}>
                                Salvar
                            </Button>
                        </Box>
                    }
                </Box>
            </Page.Title>
            <Page.Section>
                <Page.Content>
                    <Box p={2}>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Dados Técnicos
                            </Typography>
                            <Typography variant="caption" component="div">
                                Informações técnicas da bomba e suas especificações
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="tipo_preco"
                                    name="tipo_preco"
                                    label="Referência de Preço"
                                    variant="outlined"
                                    fullWidth={true}
                                    select={true}
                                    disabled={!bomba.permite_alterar}
                                    value={impostos.tipo_preco || ''}
                                    onChange={(event) => handleChangeReferencia(event.target.value)}
                                >
                                    <MenuItem value="CPP">CPP</MenuItem>
                                    <MenuItem value="Terceiros">Cotação</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Linha SAP"
                                    variant="outlined"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0 } }}
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={bomba.lin_sap || ''}
                                    onChange={(event) => setBomba({ ...bomba, lin_sap: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            {bomba.caracteristicas && bomba.caracteristicas.map((caracteristica, index) => (
                                <Grid key={index} item xs={12} md={4}>
                                    <TextField
                                        label={caracteristica.label}
                                        variant="outlined"
                                        fullWidth={true}
                                        disabled={!bomba.permite_alterar}
                                        value={caracteristica.valor || ''}
                                        onChange={(event) => handleChange(caracteristica, event.target.value)}
                                        onBlur={() => handleAutoSave()}
                                    />
                                </Grid>
                            ))}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Qtd."
                                    variant="outlined"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={impostos.qtd || ''}
                                    onChange={(event) => handleChangeImpostos('qtd', event.target.value)}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="tag"
                                    name="tag"
                                    label="TAG"
                                    variant="outlined"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={cabecalho.tag || ''}
                                    onChange={(event) => setCabecalho({ ...cabecalho, tag: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Serviço"
                                    variant="outlined"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={cabecalho.servico || ''}
                                    onChange={(event) => setCabecalho({ ...cabecalho, servico: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    options={prazos}
                                    freeSolo={true}
                                    clearText="Limpar"
                                    getOptionLabel={(option) => option.prazo}
                                    onInputChange={(_e, value) => handleChangePrazo(value)}
                                    onBlur={() => handleAutoSave()}
                                    inputValue={prazosInput || ''}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Prazo de Entrega"
                                            variant="outlined"
                                            placeholder="Ex: 80 dias"
                                            fullWidth={true}
                                            disabled={!bomba.permite_alterar}
                                        />
                                    )}
                                />
                            </Grid>
                            {impostos.tipo_preco === 'CPP' &&
                                <React.Fragment>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="cpp"
                                            name="cpp"
                                            label="Código CPP"
                                            variant="outlined"
                                            fullWidth={true}
                                            disabled={!bomba.permite_alterar}
                                            value={impostos.cpp || ''}
                                            onChange={(event) => setImpostos({ ...impostos, cpp: event.target.value })}
                                            onBlur={() => handleFetchDescricaoCPP()}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="desc_cpp"
                                            name="desc_cpp"
                                            label="Descrição CPP"
                                            variant="outlined"
                                            fullWidth={true}
                                            disabled={true}
                                            value={descricaoCPP || ''}
                                        />
                                    </Grid>
                                </React.Fragment>
                            }
                            <Grid item xs={12} md={2}>
                                <Button
                                    style={{ height: '100%' }}
                                    color="secondary"
                                    variant="contained"
                                    startIcon={<Search />}
                                    fullWidth={true}
                                    disabled={impostos.tipo_preco === 'Terceiros' || !bomba.permite_alterar}
                                    onClick={() => handleCheckPreco()}>
                                    Buscar Preço
                                </Button>
                                <Dialog open={buscarDialog} onClose={() => setBuscarDialog(false)}>
                                    <DialogTitle>Buscar Preço</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            Ao buscar a precificação, se houver valores preenchidos eles podem ser resetados, continuar?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setBuscarDialog(false)} color="primary">
                                            Cancelar
                                        </Button>
                                        <Button onClick={() => handleFetchPreco()} color="primary" autoFocus>
                                            Continuar
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Grid>
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        {impostos.tipo_preco &&
                            <React.Fragment>
                                {impostos.tipo_preco === "CPP" && precoResponse &&
                                    <React.Fragment>
                                        <Box mb={2}>
                                            <Typography variant="h6" component="div">
                                                CPP
                                            </Typography>
                                            <Typography variant="caption" component="div">
                                                Exibe os valores de precificação da bomba do tipo CPP
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Moeda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={tabela.moeda || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(tabela.cpp_valor_original)}
                                                    onChangeValue={(_e, ov) => setTabela({ ...tabela, cpp_valor_original: ov.toString() })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                    InputElement={
                                                        <TextField
                                                            label="Valor Original"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={!bomba.permite_alterar}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getConvertido(tabela.cpp_valor_original))}
                                                    InputElement={
                                                        <TextField
                                                            label="Valor Convertido"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Inf. Comercial"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.cpp_desc_inf_comercial || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Cliente"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.cpp_desc_cliente || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc."
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatDescCPP()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Adicional (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.cpp_descadc || ''}
                                                    onChange={(event) => setTabela({ ...tabela, cpp_descadc: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc. Adicional"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getValue(getFatDescAdcCPP()).toFixed(2)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Porcentagem KSB (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.cpp_porcentagem || ''}
                                                    onChange={(event) => setTabela({ ...tabela, cpp_porcentagem: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getPrecoLiqCPP())}
                                                    InputElement={
                                                        <TextField
                                                            label="Valor Total Convertido"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                    </React.Fragment>
                                }
                                {impostos.tipo_preco === "Terceiros" &&
                                    <React.Fragment>
                                        <Box mb={2}>
                                            <Typography variant="h6" component="div">
                                                Cotação
                                            </Typography>
                                            <Typography variant="caption" component="div">
                                                Exibe os valores de precificação da bomba do tipo Cotação
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Referência Fornecedor"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_referencia || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_referencia: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Moeda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.moeda || ''}
                                                    onChange={(event) => setTabela({ ...tabela, moeda: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                >
                                                    <MenuItem value="R$">R$</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="USD">USD</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(tabela.terceiros_bruto)}
                                                    onChangeValue={(_e, ov) => setTabela({ ...tabela, terceiros_bruto: ov.toString() })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Bruto Sem IPI"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={!bomba.permite_alterar}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="ICMS à Retirar"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_icmsret || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_icmsret: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                >
                                                    <MenuItem value="0">0</MenuItem>
                                                    <MenuItem value="7">7</MenuItem>
                                                    <MenuItem value="12">12</MenuItem>
                                                    <MenuItem value="13.3">13.3</MenuItem>
                                                    <MenuItem value="18">18</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="PIS/COFINS à Retirar"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_piscofinsret || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_piscofinsret: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                >
                                                    <MenuItem value="0">0</MenuItem>
                                                    <MenuItem value="9.25">9.25</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator de Importação"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_fatimp || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_fatimp: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desconto Fornecedor (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_descforn || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_descforn: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getPrecoCompraTer())}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Líquido de Compra"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Inf. Comercial"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.terceiros_desc_inf_comercial || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Cliente"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.terceiros_desc_cliente || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc."
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatDescTer()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Adicional (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_desc_adicional || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_desc_adicional: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc. Adicional"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getValue(getFatDescAdcTer()).toFixed(2)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Margem de Revenda (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!bomba.permite_alterar}
                                                    value={tabela.terceiros_margem_revenda || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_margem_revenda: event.target.value })}
                                                    onBlur={() => handleAutoSavePreco()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Revenda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatRevTer()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getPrecoLiqTer())}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Líquido de Venda"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Fatores
                            </Typography>
                            <Typography variant="caption" component="div">
                                Modificadores de preço para cálculo de valor de venda no memorial
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Fat. Enc."
                                    variant="outlined"
                                    fullWidth={true}
                                    disabled={true}
                                    value={getFatEncargos() || ''}
                                />
                            </Grid>
                            {(data.user.papel === 4 || data.user.papel === 3 || data.user.papel === 5) &&
                                <React.Fragment>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Fator de Vendas"
                                            variant="outlined"
                                            fullWidth={true}
                                            disabled={true}
                                            value={impostos.fator_vendas + '' || ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Fator Custo Material"
                                            variant="outlined"
                                            fullWidth={true}
                                            disabled={true}
                                            value={impostos.fator_custo + '' || ''}
                                        />
                                    </Grid>
                                </React.Fragment>
                            }
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Encargos
                            </Typography>
                            <Typography variant="caption" component="div">
                                Definição dos custos adicionais da bomba
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="encargo"
                                    name="encargo"
                                    label="Encargos Financeiros (%)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={true}
                                    value={encargos.encargo || ''}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="embalagem"
                                    name="embalagem"
                                    label="Encargos Embalagem (%)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={encargos.embalagem || ''}
                                    onChange={(event) => setEncargos({ ...encargos, embalagem: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="frete"
                                    name="frete"
                                    label="Encargos Frete (%)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={encargos.frete || ''}
                                    onChange={(event) => setEncargos({ ...encargos, frete: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="comissao"
                                    name="comissao"
                                    label="Encargos Comissão (%)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={encargos.comissao || ''}
                                    onChange={(event) => setEncargos({ ...encargos, comissao: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="negociacao"
                                    name="negociacao"
                                    label="Especial % (Negociação)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={encargos.negociacao || ''}
                                    onChange={(event) => setEncargos({ ...encargos, negociacao: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="custo_exportacao"
                                    name="custo_exportacao"
                                    label="Custo Exportação (%)"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    value={encargos.custo_exportacao || ''}
                                    onChange={(event) => setEncargos({ ...encargos, custo_exportacao: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="total"
                                    name="total"
                                    label="Encargos TOTAL %"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    disabled={true}
                                    value={getTotalEncargos()}
                                />
                            </Grid>
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        <Box mb={2}>
                            <Box mb={2}>
                                <Box flexDirection="row" display="flex" alignItems="center">
                                    <Box mr={1}>
                                        <Typography variant="h6" component="div">
                                            Impostos
                                        </Typography>
                                    </Box>
                                    {isLoading('tributos') && <CircularProgress size={12} color="inherit" />}
                                </Box>
                                <Typography variant="caption" component="div">
                                    Definição dos impostos que serão incluídos na bomba
                                </Typography>
                            </Box>
                        </Box>
                        <Grid className={classes.row} container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="uf_origem"
                                    name="uf_origem"
                                    label="UF de Origem"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[0]) }}
                                    disabled={(tributos[0] ? Boolean(tributos[0].disabled) : false) || !bomba.permite_alterar || isLoading('tributos') || !proposta.uf_destino || !proposta.finalidade}
                                    value={tributos[0] ? tributos[0].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(0, event.target.value)}
                                >
                                    {tributos[0] ? tributos[0].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="codimposto"
                                    name="codimposto"
                                    label="Cód. Imposto"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[1]) }}
                                    disabled={(tributos[1] ? Boolean(tributos[1].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[1] ? tributos[1].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(1, event.target.value)}
                                >
                                    {tributos[1] ? tributos[1].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="cfop"
                                    name="cfop"
                                    label="CFOP"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[2]) }}
                                    disabled={(tributos[2] ? Boolean(tributos[2].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[2] ? tributos[2].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(2, event.target.value)}
                                >
                                    {tributos[2] ? tributos[2].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="dir_fisc_icms"
                                    name="dir_fisc_icms"
                                    label="Dir.Fisc.ICMS"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[3]) }}
                                    disabled={(tributos[3] ? Boolean(tributos[3].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[3] ? tributos[3].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(3, event.target.value)}
                                >
                                    {tributos[3] ? tributos[3].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="dir_fisc_ipi"
                                    name="dir_fisc_ipi"
                                    label="Dir.Fisc.IPI"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[4]) }}
                                    disabled={(tributos[4] ? Boolean(tributos[4].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[4] ? tributos[4].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(4, event.target.value)}
                                >
                                    {tributos[4] ? tributos[4].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="lei_iss"
                                    name="lei_iss"
                                    label="Lei ISS"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[5]) }}
                                    disabled={(tributos[5] ? Boolean(tributos[5].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[5] ? tributos[5].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(5, event.target.value)}
                                >
                                    {tributos[5] ? tributos[5].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="lei_cofins"
                                    name="lei_cofins"
                                    label="Lei COFINS"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[6]) }}
                                    disabled={(tributos[6] ? Boolean(tributos[6].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[6] ? tributos[6].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(6, event.target.value)}
                                >
                                    {tributos[6] ? tributos[6].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="lei_pis"
                                    name="lei_pis"
                                    label="Lei PIS"
                                    variant="outlined"
                                    size="small"
                                    fullWidth={true}
                                    select={true}
                                    InputProps={{ classes: getTributosHighlight(tributos[7]) }}
                                    disabled={(tributos[7] ? Boolean(tributos[7].disabled) : false) || !bomba.permite_alterar || isLoading('tributos')}
                                    value={tributos[7] ? tributos[7].valor || '' : ''}
                                    onChange={(event) => handleChangeTributos(7, event.target.value)}
                                >
                                    {tributos[7] ? tributos[7].valores.map((valor, index) => (
                                        <MenuItem key={index} value={valor.cod}>{`${valor.cod} - ${valor.desc}`}</MenuItem>
                                    )) : <MenuItem></MenuItem>}
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="pis_cofins"
                                    name="pis_cofins"
                                    label="PIS/COFINS (%)"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!impostosEdit || !bomba.permite_alterar}
                                    value={impostos.pis_cofins + '' || ''}
                                    onChange={(event) => handleChangeImpostos('pis_cofins', event.target.value)}
                                    onBlur={() => handleAutoSavePreco()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="icms"
                                    name="icms"
                                    label="ICMS (%)"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!impostosEdit || !bomba.permite_alterar}
                                    value={impostos.icms + '' || ''}
                                    onChange={(event) => handleChangeImpostos('icms', event.target.value)}
                                    onBlur={() => handleAutoSavePreco()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="ipi"
                                    name="ipi"
                                    label="IPI (%)"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    fullWidth={true}
                                    disabled={!impostosEdit || !bomba.permite_alterar}
                                    value={impostos.ipi + '' || ''}
                                    onChange={(event) => handleChangeImpostos('ipi', event.target.value)}
                                    onBlur={() => handleAutoSavePreco()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Button
                                    style={{ height: '100%' }}
                                    color="default"
                                    variant="contained"
                                    startIcon={<Edit />}
                                    fullWidth={true}
                                    disabled={!bomba.permite_alterar}
                                    onClick={() => setImpostosEdit(!impostosEdit)}>
                                    Editar Impostos
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Page.Content>
            </Page.Section>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
        },
        row: {
            marginBottom: theme.spacing(1)
        },
        custom: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
        highlight: {
            borderColor: theme.palette.secondary.main,
        }
    })
);

export default PropostasDummy;